import { ReactNode } from 'react';
import { Spinner, Alert } from 'react-bootstrap';

/** Renders loading/error states, else children. */
export function AsyncBoundary({
  loading,
  error,
  children,
}: {
  loading: boolean;
  error: string | null;
  children: ReactNode;
}) {
  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" role="status" />
      </div>
    );
  }
  if (error) {
    return <Alert variant="danger">Error: {error}</Alert>;
  }
  return <>{children}</>;
}
